import "core-js/modules/es6.string.iterator";
import _toConsumableArray from "/home/runner/work/utopia-management/utopia-management/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import "core-js/modules/web.dom.iterable";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/runner/work/utopia-management/utopia-management/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/runner/work/utopia-management/utopia-management/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/utopia-management/utopia-management/node_modules/@babel/runtime-corejs2/helpers/esm/createClass";
import Vue from 'vue';
import { get as getDictDetail } from '@/api/system/dictDetail';

var Dict = /*#__PURE__*/function () {
  function Dict(dict) {
    _classCallCheck(this, Dict);

    this.dict = dict;
  }

  _createClass(Dict, [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(names, completeCallback) {
        var _this = this;

        var ps;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(names === undefined || name === null)) {
                  _context.next = 2;
                  break;
                }

                throw new Error('need Dict names');

              case 2:
                ps = [];
                names.forEach(function (n) {
                  Vue.set(_this.dict.dict, n, {});
                  Vue.set(_this.dict.label, n, {});
                  Vue.set(_this.dict, n, []);
                  ps.push(getDictDetail(n).then(function (data) {
                    var _this$dict$n;

                    (_this$dict$n = _this.dict[n]).splice.apply(_this$dict$n, [0, 0].concat(_toConsumableArray(data.content)));

                    data.content.forEach(function (d) {
                      Vue.set(_this.dict.dict[n], d.value, d);
                      Vue.set(_this.dict.label[n], d.value, d.label);
                    });
                  }));
                });
                _context.next = 6;
                return Promise.all(ps);

              case 6:
                completeCallback();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function init(_x, _x2) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return Dict;
}();

export { Dict as default };